import workflowConstants from '../constants';

const styles = theme => ({
  container: {
    padding: `10px ${workflowConstants.lg.panelContainerPaddingHorizontal}`,
    '& p': {
      color: theme.palette.primary.dim,
    },
    '& h6': {
      color: theme.palette.primary.adgmBlack,
      fontWeight: 600,
    },
  },
  list: {
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
    '& span': {
      fontWeight: 600,
      padding: '0px 10px',
    },
  },

  [`@media (max-width: ${workflowConstants.md.size}px)`]: {
    container: {
      padding: `10px ${workflowConstants.md.panelContainerPaddingHorizontal}`,
      borderBottom: '1px solid #EBEEF3',
      '& p': {
        fontSize: '12px',
      },
      '& h6': {
        fontSize: '12px',
      },
    },
    list: {
      '& span': {
        fontWeight: 500,
        fontSize: '12px',
      },
    },
  },
});

export default styles;
